'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
require('core-js/modules/es.array.find')
require('core-js/modules/es.array.splice')
exports.__esModule = true
exports.default = void 0
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'))

var _obj = require('../obj')
var _num = require('../num')
var _is = require('../is')

/**
 * Поисковик, удалятор, вставлятор, переключатор
 *
 * @class Finder
 */ var Finder = /*#__PURE__*/ (function() {
  /**
   * Создаёт экземляр Finder
   * @constructor
   * @param {Array<T>} arr массив, с которым будем работать
   * @param {ParamsType} [paramsIn]
   * @param {boolean} [paramsIn.inData] брать id и type из item.data. если не указано - true
   * @memberof Finder
   */
  function Finder(arr, paramsIn) {
    ;(0, _defineProperty2.default)(this, '_isCleared', false)
    ;(0, _defineProperty2.default)(this, '_arr', void 0)
    ;(0, _defineProperty2.default)(this, '_inData', void 0)
    ;(0, _defineProperty2.default)(this, '_finded', null)
    ;(0, _defineProperty2.default)(this, '_findedIndex', -1)
    this._arr = arr
    var params = (0, _obj.castObj)(paramsIn)
    this._inData = (0, _is.isBool)(params.inData) ? params.inData : Finder._IN_DATA_DEFAULT
  }

  /**
   * Создаёт экземпляр Finder,
   * аналогично new Finder( arr, ?params )
   *
   * @static
   * @param {Array<T>} arr
   * @param {ParamsType} [params]
   * @returns {Finder<T>}
   * @memberof Finder
   */ Finder.from = function from(arr, params) {
    return new Finder(arr, params)
  }
  Finder._createIdGetter = function _createIdGetter(inData) {
    if (!inData) {
      return function(item) {
        return item.id
      }
    }
    return function(item) {
      return item.data.id
    }
  }
  Finder._createTypeGetter = function _createTypeGetter(inData) {
    if (!inData) {
      return function(item) {
        return item.type
      }
    }
    return function(item) {
      return item.data.type
    }
  }

  /**
   * Возвращает найдённой элемент или null
   * (чистит за собой)
   *
   * @returns {(T | null)}
   * @memberof Finder
   */
  var _proto = Finder.prototype
  _proto.value = function value() {
    var f = this._finded
    this.clear()
    return f
  }

  /**
   * Возвращает индекс найденного элемента или -1
   * (чистит за собой)
   *
   * @returns {number}
   * @memberof Finder
   */
  _proto.valueInd = function valueInd() {
    var ind = (0, _num.castNum)(this._findedIndex, -1)
    this.clear()
    return ind
  }

  /**
   * Ищет по id
   *
   * @param {string} id
   * @returns {Finder<T>}
   * @memberof Finder
   */
  _proto.byId = function byId(id) {
    var _this = this
    if (this._isCleared) return this
    var inData = this._inData

    var idGetter = Finder._createIdGetter(inData)
    var item = this._arr.find(function(it, ind) {
      // $FlowFixMe
      if (idGetter(it) === id) {
        _this._findedIndex = ind
        return true
      }
      return false
    })
    this._setFinded(item)
    return this
  }

  /**
   * Ищет по id и типу
   *
   * @param {string} id
   * @param {*} type
   * @returns {Finder<T>}
   * @memberof Finder
   */
  _proto.byIdAndType = function byIdAndType(id, type) {
    var _this2 = this
    if (this._isCleared) return this
    var inData = this._inData

    var idGetter = Finder._createIdGetter(inData)
    var typeGetter = Finder._createTypeGetter(inData)

    var item = this._arr.find(function(it, ind) {
      // $FlowFixMe
      if (idGetter(it) === id && typeGetter(it) === type) {
        _this2._findedIndex = ind
        return true
      }
      return false
    })
    this._setFinded(item)
    return this
  }

  /**
   * Ищет переданный item
   * заполняет _finded и _findedIndex
   *
   * @param {T} item
   * @returns {Finder<T>}
   * @memberof Finder
   */
  _proto.byItem = function byItem(item) {
    if (this._isCleared) return this

    var id = Finder._createIdGetter(this._inData)(item)
    var type = Finder._createTypeGetter(this._inData)(item)
    if ((0, _is.isStr)(type)) {
      this.byIdAndType(id, type)
    } else {
      this.byId(id)
    }

    return this
  }

  /**
   * Удаляет элемент, если он был найден
   *
   * @memberof Finder
   */
  _proto.del = function del() {
    if (this._isCleared) return

    var findedIndex = this._findedIndex

    if (findedIndex !== -1) {
      this._arr.splice(findedIndex, 1)
    }

    this.clear()
  }

  /**
   * Вставляет элемент, если его нет в массиве
   *
   * @param {T} item
   * @memberof Finder
   */
  _proto.pushIfNotExist = function pushIfNotExist(item) {
    if (this._isCleared) return
    this.byItem(item)
    if (this._findedIndex === -1) {
      this._arr.push(item)
    }
    this.clear()
  }

  /**
   * Добавляет элемент, если его нет в массиве
   * Исключает, если есть
   *
   * @param {T} item
   * @param {boolean} [force]
   * @memberof Finder
   */
  _proto.toggle = function toggle(item, force) {
    if (this._isCleared || (0, _is.isNull)(item)) return
    this.byItem(item)

    var isIn = this._findedIndex !== -1

    if (force === true) {
      if (!isIn) {
        this._arr.push(item)
      }
      this.clear()
      return
    }

    if (force === false) {
      if (isIn) {
        this.del()
      }
      this.clear()
      return
    }

    if (isIn) {
      this.del()
    } else {
      this._arr.push(item)
    }

    this.clear()
  }
  _proto._setFinded = function _setFinded(item) {
    this._finded = (0, _is.isUndef)(item) ? null : item
  }

  /**
   * Прибирает за собой. После вызова не имеет смысла вызывать какие-либо методы
   * Автоматически вызывается после value, valueInd, del, pushIfNotExist, toggle
   *
   * @memberof Finder
   */
  _proto.clear = function clear() {
    if (this._isCleared) return
    delete this._arr
    this._finded = null
    this._findedIndex = -1
    this._isCleared = true
  }
  return Finder
})()
;(0, _defineProperty2.default)(Finder, '_IN_DATA_DEFAULT', true)
var _default = Finder
exports.default = _default



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/arr/Finder.js
// module id = 635
// module chunks = 0